import {Component} from '@angular/core'
import {NbIconLibraries} from '@nebular/theme'
import * as moment from 'moment'

@Component({
  selector: 'sdm-app',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private iconsLibrary: NbIconLibraries) {
    moment.locale('cs')
    iconsLibrary.registerFontPack('ion', {iconClassPrefix: 'ion'})
    iconsLibrary.registerFontPack('fa', {packClass: 'fa', iconClassPrefix: 'fa'})
  }
}
